import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "simulation-card" }
const _hoisted_4 = {
  id: "lMenu",
  class: "sidebar-simulation"
}
const _hoisted_5 = { class: "row sidebar-stat tray-bin" }
const _hoisted_6 = {
  id: "divContador",
  class: "sidebar-content"
}
const _hoisted_7 = {
  key: 1,
  class: "unauthorized-container"
}

import { ref, watch, computed } from "vue";
import AIAssistant from "./components/ai-assistant/AIAssistant.vue";
import DevPanel from "./components/dev/DevPanel.vue";
import { useKeyboardShortcuts } from "./composables/useKeyboardShortcuts";
import { useTestConfig } from "./composables/useTestConfig";
import { isLocalEnv } from "@/utils/IdentifyGlobalEnv";

// Initialize keyboard shortcuts for dev panel

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useKeyboardShortcuts();

// Check if we're in local environment
const isLocalEnvironment = computed(() => isLocalEnv());

// Use shared test config
const { config: testConfig } = useTestConfig();

// Computed assistant props that combine shared config
const assistantProps = computed(() => ({
  position: testConfig.value.position,
  token: testConfig.value.token,
  userId: testConfig.value.userId,
  patientId: testConfig.value.patientId,
  licenseId: testConfig.value.licenseId,
  bookingId: testConfig.value.bookingId,
  pms: testConfig.value.pms,
  professionalId: testConfig.value.professionalId,
  config: {
    autoStart: testConfig.value.autoStart,
    featureFlags: [] as string[],
  },
}));

const attendanceStarted = ref(false);

function handleStartAttendance() {
  attendanceStarted.value = true;
}

function handleEndAttendance() {
  attendanceStarted.value = false;
}

// Dev-only: mirror testConfig into document.userProperties for easier dev integration
function setDevUserProperties() {
  const config = testConfig.value;
  (document as any).userProperties = {
    ...(document as any).userProperties,
    usuarioID: config.userId,
    pacienteID: config.patientId,
    licencaID: config.licenseId,
    agendamentoID: config.bookingId,
    profissionalID: config.professionalId,
  };
}

// Dev-only: Mock iPront function for local development
if (typeof (window as any).iPront === "undefined") {
  (window as any).iPront = (
    type: string,
    patientId: number,
    formId: number,
    insertedFormId: string,
    extra: string
  ) => {
    console.log("🎉 [DEV] iPront called with:", { type, patientId, formId, insertedFormId, extra });
  };
}

// Keep document.userProperties in sync with test config
watch(testConfig, () => setDevUserProperties(), { deep: true, immediate: true });

return (_ctx: any,_cache: any) => {
  return (isLocalEnvironment.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "app-background" }, null, -1)),
        _createElementVNode("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createStaticVNode("<header class=\"hero\" data-v-0161a2ae><div class=\"hero-content\" data-v-0161a2ae><div class=\"logo-container\" data-v-0161a2ae><img class=\"logo\" alt=\"Feegow logo\" src=\"assets/img/logo-feegow.svg\" data-v-0161a2ae><span class=\"logo-badge\" data-v-0161a2ae>DEV</span></div><h1 class=\"hero-title\" data-v-0161a2ae>AI Assistant</h1><p class=\"hero-subtitle\" data-v-0161a2ae>Development Environment</p><div class=\"hero-hint\" data-v-0161a2ae><kbd data-v-0161a2ae>Ctrl</kbd><span data-v-0161a2ae>+</span><kbd data-v-0161a2ae>Shift</kbd><span data-v-0161a2ae>+</span><kbd data-v-0161a2ae>D</kbd><span class=\"hint-text\" data-v-0161a2ae>to open Dev Panel</span></div></div></header>", 1)),
          _createElementVNode("main", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"card-header\" data-v-0161a2ae><div class=\"card-icon\" data-v-0161a2ae><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" width=\"24\" height=\"24\" data-v-0161a2ae><rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" ry=\"2\" data-v-0161a2ae></rect><line x1=\"3\" x2=\"21\" y1=\"9\" y2=\"9\" data-v-0161a2ae></line><path d=\"m9 16 2 2 4-4\" data-v-0161a2ae></path></svg></div><div class=\"card-title-group\" data-v-0161a2ae><h2 class=\"card-title\" data-v-0161a2ae>Feegow PMS Simulation</h2><p class=\"card-subtitle\" data-v-0161a2ae>Simulated sidebar environment for testing</p></div></div>", 1)),
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!attendanceStarted.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn-acao-atendimento btn-success pms-btn start",
                          onClick: handleStartAttendance
                        }, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("span", { class: "btn-indicator" }, null, -1),
                          _createElementVNode("span", { class: "btn-text" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              fill: "currentColor",
                              width: "16",
                              height: "16"
                            }, [
                              _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                            ]),
                            _createTextVNode(" Iniciar Atendimento ")
                          ], -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            class: "pms-btn end",
                            onClick: handleEndAttendance
                          }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              width: "16",
                              height: "16"
                            }, [
                              _createElementVNode("rect", {
                                width: "14",
                                height: "14",
                                x: "5",
                                y: "5",
                                rx: "2",
                                ry: "2"
                              })
                            ], -1),
                            _createTextVNode(" Finalizar Atendimento ", -1)
                          ]))]),
                          _cache[2] || (_cache[2] = _createElementVNode("button", { class: "pms-btn pause" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              fill: "currentColor",
                              width: "16",
                              height: "16"
                            }, [
                              _createElementVNode("rect", {
                                width: "4",
                                height: "14",
                                x: "6",
                                y: "5",
                                rx: "1"
                              }),
                              _createElementVNode("rect", {
                                width: "4",
                                height: "14",
                                x: "14",
                                y: "5",
                                rx: "1"
                              })
                            ]),
                            _createTextVNode(" Pausar Atendimento ")
                          ], -1))
                        ], 64))
                  ])
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"card-footer\" data-v-0161a2ae><span class=\"footer-note\" data-v-0161a2ae><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" width=\"14\" height=\"14\" data-v-0161a2ae><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-0161a2ae></circle><line x1=\"12\" x2=\"12\" y1=\"8\" y2=\"12\" data-v-0161a2ae></line><line x1=\"12\" x2=\"12.01\" y1=\"16\" y2=\"16\" data-v-0161a2ae></line></svg> NOA AI Assistant CTA appears below start button </span></div>", 1))
            ])
          ])
        ]),
        _createVNode(AIAssistant, _normalizeProps(_guardReactiveProps(assistantProps.value)), null, 16),
        _createVNode(DevPanel)
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [
        _createStaticVNode("<div class=\"unauthorized-card\" data-v-0161a2ae><div class=\"unauthorized-icon\" data-v-0161a2ae><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" width=\"48\" height=\"48\" data-v-0161a2ae><rect width=\"18\" height=\"11\" x=\"3\" y=\"11\" rx=\"2\" ry=\"2\" data-v-0161a2ae></rect><path d=\"M7 11V7a5 5 0 0 1 10 0v4\" data-v-0161a2ae></path></svg></div><h1 class=\"unauthorized-title\" data-v-0161a2ae>Unauthorized Access</h1><p class=\"unauthorized-message\" data-v-0161a2ae> This environment is restricted to local development only. </p><div class=\"unauthorized-hint\" data-v-0161a2ae><span class=\"hint-label\" data-v-0161a2ae>Allowed origin:</span><code data-v-0161a2ae>localhost</code></div></div>", 1)
      ]))]))
}
}

})